import Collector from './collector';

const logCollector = new Collector({
  env: import.meta.env.NODE_ENV,
  delay: 5000,
  printLog: import.meta.env.NODE_ENV === 'dev' ? true : false
});

export default logCollector;
